export default __webpack_public_path__ + "static/media/plus1.fb78c29c.jpg";